import styles from "./map-view.module.css";

export default function MapViewLoading() {
  return (
    <div className={styles.customMapContainer}>
      <input
        type="text"
        className={`${styles.locationInput} ${styles.locationInputLoading}`}
        placeholder="Enter a location..."
      />
      <div className={`${styles.mapContainer} ${styles.isLoading}`}></div>
    </div>
  );
}
